import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/product-batches/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const productBatches = {
  getAll: apiPathFunc(pathBase),
};
